import { NavLink, Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import { EVENTS } from '@shared/events.js';
import CubeMark from './CubeMark.jsx';
import { IconHome, IconTimer, IconChart, IconUsers, IconGear } from './icons.jsx';

function eventName(key) {
  const e = EVENTS.find((x) => x.key === key);
  return e ? e.name : key;
}

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isCoach = user?.role === 'coach';

  const links = isCoach
    ? [
        { to: '/coach', label: '学生管理', Icon: IconUsers },
      ]
    : [
        { to: '/', label: '首页', Icon: IconHome },
        { to: '/timer', label: '计时器', Icon: IconTimer },
        { to: '/data', label: '我的数据', Icon: IconChart },
      ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-20 backdrop-blur bg-ink-900/85 border-b border-slate-800">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between gap-3">
          <Link to={isCoach ? '/coach' : '/'} className="flex items-center gap-2 shrink-0">
            <CubeMark size={26} />
            <span className="font-bold text-slate-100 tracking-wide">
              Cube<span className="text-accent">Coach</span>
            </span>
            <span className="hidden sm:inline text-xs text-slate-500 ml-1">魔方训练营</span>
          </Link>

          <nav className="flex items-center gap-1 sm:gap-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/' || l.to === '/coach'}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-lg text-sm transition-colors ${
                    isActive ? 'bg-accent/15 text-accent font-medium' : 'text-slate-400 hover:text-slate-100 hover:bg-slate-700/40'
                  }`
                }
              >
                <l.Icon />
                <span className="hidden md:inline">{l.label}</span>
              </NavLink>
            ))}
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                `px-2.5 sm:px-3 py-1.5 rounded-lg text-sm transition-colors ${
                  isActive ? 'bg-accent/15 text-accent' : 'text-slate-400 hover:text-slate-100 hover:bg-slate-700/40'
                }`
              }
              title="设置"
            >
              <IconGear />
            </NavLink>
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-sm text-slate-200 max-w-[120px] truncate">{user?.nickname}</span>
              <span className="text-[11px] text-slate-500">
                {isCoach ? '教练' : `主项目 ${eventName(user?.main_event)}`}
              </span>
            </div>
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-accent to-violet flex items-center justify-center text-ink-950 font-bold text-sm">
              {(user?.nickname || '?').slice(0, 1)}
            </div>
            <button onClick={handleLogout} className="text-slate-500 hover:text-danger text-sm px-1" title="退出登录">
              退出
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 w-full max-w-6xl mx-auto px-4 py-6">
        <Outlet />
      </main>

      <footer className="text-center text-xs text-slate-600 py-6">
        魔方训练营 · 训练打卡与成绩追踪
      </footer>
    </div>
  );
}
